import { icon } from '../components/icons';
import { insightsList } from '../components/insights-list';
import { eyebrow, mesh } from '../components/primitives';
import { ctaBand } from '../components/sections';
import { SOCIAL_PROFILES, configuredNetworks } from '../components/social';
import { INSIGHT_CATEGORIES, isInsightCategory, type InsightCategory } from '../content/insight-categories';
import { EXTERNAL_LINK_ATTRS, NEW_TAB_NOTE } from '../lib/links';

function followSection(): string {
  const networks = configuredNetworks();
  if (!networks.length) return '';
  const cards = networks
    .map((k) => {
      const m = SOCIAL_PROFILES[k];
      return `<li><a class="fcard" href="${m.url()}" ${EXTERNAL_LINK_ATTRS}><span class="fi">${icon(k)}</span><span class="ft"><b>${m.name}</b><small>${m.desc}</small>${m.note ? `<small class="fn">${m.note}</small>` : ''}</span><span class="fgo">${m.cta} ${icon('arrow')}</span>${NEW_TAB_NOTE}</a></li>`;
    })
    .join('');
  return `
  <section class="s tight-top" aria-labelledby="follow-h">
    <div class="wrap">
      <div class="follow rv">
        <div class="follow-head">${eyebrow('Follow the conversation')}<h2 id="follow-h" class="h-card" style="margin-top:12px">More from ReTax360</h2><p class="muted">Follow ReTax360 across our channels for perspectives on AI orchestration, property tax operations, enterprise technology and the future of intelligent workflows.</p></div>
        <ul class="fcards">${cards}</ul>
      </div>
    </div>
  </section>`;
}

export function pageInsights(query: URLSearchParams): string {
  const requested = query.get('category');
  const category: InsightCategory = isInsightCategory(requested) ? requested : '';
  return `
  <section class="hero compact" aria-labelledby="h1">
    ${mesh()}
    <div class="wrap rv">
      ${eyebrow('Insights')}
      <h1 id="h1">Insights</h1>
      <p class="lede" style="margin-top:20px">Perspectives on AI orchestration, property tax operations and enterprise AI from the ReTax360 team.</p>
      <p class="statement">The next generation of enterprise software won't just store work. <span class="grad">It will coordinate it.</span></p>
      <p class="sig-mark">RETAX360</p>
    </div>
  </section>
  <section class="s" aria-label="Articles">
    <div class="wrap">
      <div class="cats" role="tablist" aria-label="Filter by category" data-cats>
        ${INSIGHT_CATEGORIES.map(([k, l]) => `<button role="tab" class="cat" aria-selected="${k === category}" tabindex="${k === category ? 0 : -1}" data-cat="${k}" aria-controls="posts">${l}</button>`).join('')}
      </div>
      <div id="posts" role="tabpanel" aria-live="polite" tabindex="0">${insightsList(category)}</div>
    </div>
  </section>
  ${followSection()}
  ${ctaBand()}`;
}
